import { Popover as MuiPopover, PopoverProps } from '@mui/material';

export const Popover = (props: PopoverProps) => (<MuiPopover {...props} />);
